mutation LockDafAdminFeePeriod($id: ID!) {
  lockDafAdminFeePeriod(input: { id: $id }) {
    dafAdminFeePeriod {
      id
      name
      startDate
      endDate
      lockedDate
      fundAdminFees {
        id
        baseCurrency
        averageDailyBalanceGross {
          minorUnit
          currency
        }
        hifoDiscount {
          minorUnit
          currency
        }
        equivalentYearlyFee {
          minorUnit
          currency
        }
        monthlyFee {
          minorUnit
          currency
        }
        feeWaived
        feeWaivedReasons
        caseStatus
        applicableDafPlan
        feeStartDate
        period {
          id
          name
          startDate
          endDate
          lockedDate
        }
        fund {
          id
          name
          legalEntity {
            id
            name
          }
        }
        calculationData {
          tieredFees {
            fee {
              minorUnit
              currency
            }
            amount {
              minorUnit
              currency
            }
            rate
          }
        }
        fundAccountAdminFees {
          id
          fundAccount {
            id
            currency
            sageCode
          }
          caseStatus
          salesforceCaseId
          monthlyFee {
            minorUnit
            currency
          }
        }
      }
    }
  }
}
